import React from 'react';
import { Link } from 'react-router-dom';
import { Seo } from '../shared';
import { companyDetails } from '../../helpers';

const TermsOfService = () => (
	<div className="container px-md-4 py-md-4 page">
		<Seo
			title="Terms of Service"
			path="/terms"
			description="Terms of Service for Visit All Nepal — use of our travel guides, website, and booking services."
		/>
		<div className="legal-page card border-0 shadow-sm p-4 p-md-5">
			<h1 className="title mb-4">Terms of Service</h1>
			<p className="text-muted small">
				Last updated: {new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}
			</p>

			<p>
				These Terms of Service (&quot;Terms&quot;) govern your use of the Visit All Nepal website at visitallnepal.com
				and related services operated by Visit All Nepal (&quot;we&quot;, &quot;us&quot;, &quot;our&quot;). By accessing
				or using our site, you agree to these Terms. If you do not agree, please do not use the site.
			</p>

			<h2 className="h5 text-primary mt-4 mb-2">1. Our services</h2>
			<p>
				Visit All Nepal provides Nepal travel guides (including guided journeys, destination articles, festival
				information, and trip-planning resources) and booking services for group departures, private tours, and
				shared transportation arranged through our platform. Travel services are fulfilled by verified local operators
				assigned by Visit All Nepal.
			</p>

			<h2 className="h5 text-primary mt-4 mb-2">2. Travel guides and content</h2>
			<p>
				Our guides are published for general trip-planning purposes. Conditions on the ground — weather, trail
				conditions, permit rules, festival dates, prices, and transport schedules — can change. Always verify
				critical details (especially visas, permits, and safety) with official sources before you travel. We strive
				for accuracy but do not guarantee that every detail is current at all times.
			</p>

			<h2 className="h5 text-primary mt-4 mb-2">3. Accounts and bookings</h2>
			<p>
				Some features require an account. You are responsible for keeping your login credentials secure and for
				activity under your account. When you submit a booking or tour request, you agree to provide accurate
				information. Deposits, balances, cancellation rules, and refunds are explained at checkout and in
				booking confirmations — they may differ by product (group departure, private tour, shared ride).
			</p>

			<h2 className="h5 text-primary mt-4 mb-2">4. Acceptable use</h2>
			<p>You agree not to:</p>
			<ul className="legal-list pl-4">
				<li>Use the site for unlawful purposes or to submit false booking information.</li>
				<li>Scrape, copy, or republish substantial portions of our content without permission.</li>
				<li>Attempt to disrupt the site, bypass security, or access areas reserved for administrators or partners.</li>
				<li>Use automated tools to overload our servers or misrepresent traffic.</li>
			</ul>

			<h2 className="h5 text-primary mt-4 mb-2">5. Intellectual property</h2>
			<p>
				Text, graphics, logos, journey structures, and other materials on Visit All Nepal are owned by us or
				our licensors and protected by applicable copyright laws. You may read and share links to our pages for
				personal, non-commercial use. Commercial reuse requires our written consent.
			</p>

			<h2 className="h5 text-primary mt-4 mb-2">6. Third-party services and advertising</h2>
			<p>
				We use third-party services for analytics, payments, email, and (where enabled) advertising such as
				Google AdSense. Those providers may use cookies or similar technologies as described in our{' '}
				<Link to="/privacy">Privacy Policy</Link>. Links to external websites are provided for convenience; we
				are not responsible for third-party content or policies.
			</p>

			<h2 className="h5 text-primary mt-4 mb-2">7. Disclaimer of warranties</h2>
			<p>
				The site and content are provided &quot;as is&quot; and &quot;as available&quot; without warranties of any
				kind, express or implied, including fitness for a particular purpose. Trekking and adventure travel
				involve inherent risks; you are responsible for your own fitness, insurance, and decisions on the trail.
			</p>

			<h2 className="h5 text-primary mt-4 mb-2">8. Limitation of liability</h2>
			<p>
				To the fullest extent permitted by law, Visit All Nepal shall not be liable for indirect, incidental,
				special, or consequential damages arising from your use of the site or travel services booked through
				us. Our total liability for any claim relating to the site shall not exceed the amount you paid us for
				the booking giving rise to the claim in the twelve months before the claim.
			</p>

			<h2 className="h5 text-primary mt-4 mb-2">9. Changes</h2>
			<p>
				We may update these Terms from time to time. The &quot;Last updated&quot; date at the top will change
				when we do. Continued use of the site after changes constitutes acceptance of the revised Terms.
			</p>

			<h2 className="h5 text-primary mt-4 mb-2">10. Contact</h2>
			<p>
				Questions about these Terms:{' '}
				<a href={`mailto:${companyDetails.email}`}>{companyDetails.email}</a>
				{' '}or our <Link to="/support">support page</Link>.
			</p>

			<hr className="my-4" />
			<p className="small text-muted mb-0">
				See also: <Link to="/privacy">Privacy Policy</Link> · <Link to="/about">About Visit All Nepal</Link>
			</p>
		</div>
	</div>
);

export default TermsOfService;
